import React, {useContext, useEffect, useState} from 'react';
import {
    Box,
    Button,
    Grid,
    FormControl,
    Input,
    InputLabel,
    useToastProvider,
    FormHelperText
} from '@deere/fuel-react';
import {useAuthConfig} from "../shared/helper";
import {FormSelect} from "../shared/FormSelect";
import {Controller, useForm} from "react-hook-form";
import {ModalDialog} from "../shared/ModalDialog";
import {ReasonsContext} from './Ratings';

export const RatingsOverrideScore = ({
                                         criteriaId,
                                         suppliers,
                                         originalValue,
                                         overrideValue,
                                         criteria,
                                         isEdit = false,
                                         onOverrideScoreAction
                                     }) => {
    const {enqueueToast} = useToastProvider();
    let authAxios = useAuthConfig();
    const [reasonsList, setReasonsList] = useState([]);
    const [reasonValue, setReasonValue] = useState("");
    const [comment, setComment] = useState("");
    const [error, setError] = useState("");
    const {control} = useForm();
    const reasons = useContext(ReasonsContext);

    const onCancel = () => {
        onOverrideScoreAction("", "cancel")
    }

    const onDelete = () => {
        authAxios.delete(`/ratingOverride/${criteria.overrideReason.id}`)
            .then(res => {
                onOverrideScoreAction(res, "delete")
                enqueueToast({
                    variant: "success",
                    title: "Deleted Successfully",
                    isCloseable: true
                });
            }).catch((error) => {
            enqueueToast({
                variant: "error",
                title: "System Error",
                isPersistent: true
            });
            console.log(error);
        });
    }

    const onSubmit = () => {
        if (overrideValue > originalValue) {
            setError("Enter value less than the total weightage")
        } else if (overrideValue < 0) {
            setError("Enter value greater than 0")
        } else if(criteria.notApplicableReason){
            setError("Rating override can't be applied as N/A already added")
        }
        else {
            if (criteria.overrideReason !== null) {
                if (overrideValue !== null && reasonValue && comment) {
                    setError("");
                    const supplierNumbers = suppliers.map(item => item.supplierNumber)
                    const putData = {
                        "criteriaId": criteriaId,
                        "supplierNumbers": supplierNumbers,
                        "reasonId": parseInt(reasonValue),
                        "overridePoints": parseInt(overrideValue),
                        "weightage": originalValue,
                        "comments": comment
                    }
                    authAxios.put(`/ratingOverride/${criteria.overrideReason.id}`, putData)
                        .then(res => {
                            onOverrideScoreAction(res, "update")
                            enqueueToast({
                                variant: "success",
                                title: "Updated Successfully",
                                isCloseable: true
                            });
                        }).catch((error) => {
                        enqueueToast({
                            variant: "error",
                            title: "System Error",
                            message: error.response ? error.response.data[error.response.status] : "",
                            isPersistent: true
                        });
                        console.log(error);
                    });
                } else {
                    setError("Override Reason and Comments are required  sddfs")
                }
            } else {
                if (overrideValue !== null && reasonValue && comment) {
                    setError("");
                    const supplierNumbers = suppliers.map(item => item.supplierNumber)
                    const postData = {
                        "criteriaId": criteriaId,
                        "supplierNumbers": supplierNumbers,
                        "reasonId": parseInt(reasonValue),
                        "overridePoints": parseInt(overrideValue),
                        "weightage": originalValue,
                        "comments": comment
                    }
                    authAxios.post(`/ratingOverride`, postData)
                        .then(res => {
                            onOverrideScoreAction(res, "save")
                            enqueueToast({
                                variant: "success",
                                title: "Saved Successfully",
                                isCloseable: true
                            });
                        }).catch((error) => {
                        enqueueToast({
                            variant: "error",
                            title: "System Error",
                            message: error.response ? error.response.data[error.response.status] : "",
                            isPersistent: true
                        });
                        console.log(error);
                    });
                } else {
                    setError("Override Reason and Comments are required frbxg")
                }
            }
        }
    }

    const handleReasonChange = (event) => {
        setReasonValue(event.target.value);
    };

    useEffect(() => {
        const filteredData = reasons.filter(item => item.type === "override")
        setReasonsList(filteredData);

        return () => {
            setReasonsList([]);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (criteria.overridePoints || criteria.overrideReason) {
            setComment(criteria.overrideReason.comments)
            setReasonValue(criteria.overrideReason.reasonId)
        }
    }, [criteria])

    return (
        <Grid container>
            <Grid item xs={4}>
                <Box p={2}>
                    <FormSelect
                        label={"Override Reason"}
                        defValue={reasonValue}
                        name={"Override Reason"}
                        options={reasonsList}
                        onTypeChange={handleReasonChange}
                        control={control}
                        isShowSelect={true}
                        required={true}
                        type={"overrideScore"}
                    />
                </Box>
            </Grid>
            <Grid item xs={8}>
                <Box p={2}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="reasonComment">Comments
                            <span style={{
                                marginLeft: ".25rem",
                                display: "inline"
                            }}
                                  aria-label="required field"
                                  className="uxf-is-required"
                            > * </span>
                        </InputLabel>
                        <Controller
                            rules={{required: true}}
                            control={control}
                            defaultValue={comment}
                            value={comment}
                            name={"reasonComment"}
                            render={({onChange, value}) => (
                                <Input fullWidth
                                       id="reasonComment"
                                       placeholder="Start Typing Comment..."
                                       value={comment}
                                       onChange={(e) => {
                                           onChange(e.target.value)
                                           setComment(e.target.value)
                                       }}
                                />
                            )}
                        />
                    </FormControl>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-end">
                    <FormHelperText error={error !== ""} style={{padding: ".5rem"}}>{error}</FormHelperText>
                    {isEdit &&
                    <ModalDialog
                        titleText={"Delete Override"}
                        content={<React.Fragment> Are you sure you want to delete the override?</React.Fragment>}
                        saveButtonText={"Delete"}
                        onSave={onDelete}
                        page={"Ratings"}
                    />
                    }
                    <Button variant="secondary" style={{marginRight: ".5rem"}} size="medium" onClick={() => {
                        onCancel()
                    }}>Cancel</Button>
                    <Button variant="primary" size="medium" type="submit"
                            onClick={() => onSubmit()}
                    >Save</Button>
                </Box>
            </Grid>
        </Grid>
    )
}
